"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectRichTextSourcesFromScene = void 0;
exports.isEntityUuid = isEntityUuid;
exports.getEntityVisitSelectionInRichText = getEntityVisitSelectionInRichText;
exports.getEntityVisitSelectionInHydratedScene = getEntityVisitSelectionInHydratedScene;
exports.getEntityReferenceSelectionConfigInRichText = getEntityReferenceSelectionConfigInRichText;
exports.getEntityReferenceSelectionConfigInHydratedScene = getEntityReferenceSelectionConfigInHydratedScene;
exports.validateEntityReferenceSelectionInHydratedScene = validateEntityReferenceSelectionInHydratedScene;
const colorPickerRichText_1 = require("./colorPickerRichText");
Object.defineProperty(exports, "collectRichTextSourcesFromScene", { enumerable: true, get: function () { return colorPickerRichText_1.collectRichTextSourcesFromScene; } });
const ENTITY_UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
function isEntityUuid(value) {
    return ENTITY_UUID_PATTERN.test(String(value ?? '').trim());
}
function getNestedRichTextElements(element) {
    const out = [];
    if (element.type === 'conditional') {
        if (Array.isArray(element.children)) {
            out.push(...element.children);
        }
        if (Array.isArray(element.elseChildren)) {
            out.push(...element.elseChildren);
        }
        return out;
    }
    if (element.type === 'inline-option' && Array.isArray(element.content)) {
        out.push(...element.content);
        return out;
    }
    if (Array.isArray(element.content)) {
        for (const item of element.content) {
            if (item && typeof item === 'object' && 'type' in item) {
                out.push(item);
            }
        }
    }
    return out;
}
function isVisitModeEntityList(el) {
    const st = el.entityListSelectionTarget;
    const sv = el.entityListSelectionVariable;
    const source = (el.entityListSource || '').trim();
    // Foreign lists are never visit mode (reference-only in v1).
    return !st && !sv && !source;
}
function isReferenceModeEntityList(el, variableName, targetScene) {
    return (el.entityListSelectionTarget === targetScene &&
        el.entityListSelectionVariable === variableName);
}
/**
 * True if `entityId` appears in a visit-mode `<Entity-List>` on the current scene
 * (no selectionTarget/selectionVariable).
 */
function getEntityVisitSelectionInRichText(elements, entityId) {
    const walk = (elts) => {
        for (const el of elts) {
            if (el.type === 'entity-list' && isVisitModeEntityList(el)) {
                const rows = el.entityListRows ?? [];
                for (const row of rows) {
                    if (row.entityId === entityId) {
                        return {
                            allowed: true,
                            startSceneId: row.startSceneId
                        };
                    }
                }
            }
            const nested = walk(getNestedRichTextElements(el));
            if (nested.allowed) {
                return nested;
            }
        }
        return { allowed: false };
    };
    return walk(elements);
}
function getEntityVisitSelectionInHydratedScene(scene, entityId) {
    for (const fragment of (0, colorPickerRichText_1.collectRichTextSourcesFromScene)(scene)) {
        const desc = (0, colorPickerRichText_1.toRichTextDescription)(fragment);
        if (!desc) {
            continue;
        }
        const result = getEntityVisitSelectionInRichText(desc.elements, entityId);
        if (result.allowed) {
            return result;
        }
    }
    return { allowed: false };
}
/**
 * True if `entityId` is a valid pick for reference mode on the current scene:
 * some `<Entity-List>` embed matches `variableName` + `targetScene`, and the id
 * appears in server-hydrated {@link RichTextElement.entityListRows}.
 */
function getEntityReferenceSelectionConfigInRichText(elements, variableName, targetScene, entityId) {
    const walk = (elts) => {
        for (const el of elts) {
            if (el.type === 'entity-list' && isReferenceModeEntityList(el, variableName, targetScene)) {
                const rows = el.entityListRows ?? [];
                for (const row of rows) {
                    if (row.entityId === entityId) {
                        return { allowed: true };
                    }
                }
            }
            const nested = walk(getNestedRichTextElements(el));
            if (nested.allowed) {
                return nested;
            }
        }
        return { allowed: false };
    };
    return walk(elements);
}
function getEntityReferenceSelectionConfigInHydratedScene(scene, variableName, targetScene, entityId) {
    for (const fragment of (0, colorPickerRichText_1.collectRichTextSourcesFromScene)(scene)) {
        const desc = (0, colorPickerRichText_1.toRichTextDescription)(fragment);
        if (!desc) {
            continue;
        }
        const config = getEntityReferenceSelectionConfigInRichText(desc.elements, variableName, targetScene, entityId);
        if (config.allowed) {
            return config;
        }
    }
    return { allowed: false };
}
function validateEntityReferenceSelectionInHydratedScene(scene, variableName, targetScene, entityId) {
    return getEntityReferenceSelectionConfigInHydratedScene(scene, variableName, targetScene, entityId).allowed;
}
//# sourceMappingURL=entityListReferenceRichText.js.map